import { ProvinceConfigurationImpl } from "../data/ProvinceConfigurationImpl";
import { IProvinceConfigurationRepository } from "../domain/repositories/IProvinceConfigurationRepository";
import { ProvinceConfigurationUseCase } from "../domain/useCases/ProvinceConfigurationUseCase";
import { ProvinceConfigurationViewModel } from "../presentation/viewModel/ProvinceConfigurationViewModel";
import { InjectionBinding, InjectionModule } from "app/di/DependencyInjections";

export class ProvinceConfigurationInjection extends InjectionModule {
  private static readonly provinceConfigurationRepositoryToken = Symbol(
    "IProvinceConfigurationRepository",
  );
  private static readonly provinceConfigurationUseCaseToken = Symbol(
    "ProvinceConfigurationUseCase",
  );
  private static readonly provinceConfigurationViewModelToken = Symbol(
    "ProvinceConfigurationViewModel",
  );

  protected static override bindings: InjectionBinding[] = [
    {
      scope: "otherRepo",
      token: this.provinceConfigurationRepositoryToken,
      useClass: ProvinceConfigurationImpl,
    },
    {
      scope: "otherRepo",
      token: this.provinceConfigurationUseCaseToken,
      useClass: ProvinceConfigurationUseCase,
    },
    {
      scope: "viewModel",
      token: this.provinceConfigurationViewModelToken,
      useClass: ProvinceConfigurationViewModel,
    },
  ];

  static getRepo(): IProvinceConfigurationRepository {
    return this.resolve(this.provinceConfigurationRepositoryToken);
  }

  static getUseCase(): ProvinceConfigurationUseCase {
    return this.resolve(this.provinceConfigurationUseCaseToken);
  }
}
